// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { Company } from '../../../types/company'
import type { PropertyError } from '../../../types/validation-error-result'
import type { Module } from 'vuex'
import { buildCompany } from '../../../types/company'
import type {CompanySelfServiceStatus} from '../../../types/company-self-service-status'
import {buildCompanySelfServiceStatus} from '../../../types/company-self-service-status'

export type CompanyState = {
  company: Company,
  companyValidationErrors: ?PropertyError[],
  selfServiceStatus: CompanySelfServiceStatus,
}
const initialState = (): CompanyState => {
  return {
    company: buildCompany(),
    companyValidationErrors: null,
    selfServiceStatus: buildCompanySelfServiceStatus()
  }
}

export type CompanyModule = Module<CompanyState>

const companyModule: CompanyModule = {
  namespaced: true,
  state: initialState(),
  initialState: initialState(),
  getters,
  mutations,
  actions
}

export default companyModule



// WEBPACK FOOTER //
// ./src/store/modules/company/index.js